import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { useLocation } from "react-router-dom";
import queryString from 'query-string';
import Select from 'react-select'

// components
import {
    Card,
    Container,
    Row,
    Col,
    FormGroup,
    Input,
    Button,
    CardBody,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    DropdownToggle,
    Navbar,
    Nav,
    Media,
    Spinner,
    Tooltip as TooltipAviso
} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faBars, faClipboardList, faGears, faList, faMagnifyingGlassLocation, faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import { Map, Marker, GeoJSON, Tooltip, Polyline, Popup } from 'react-leaflet'
import L from 'leaflet'
import MaterialTable from "material-table";
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import MarkerClusterGroup from 'react-leaflet-markercluster';

// style
import "assets/css/map.css";
import "assets/css/mapAnaliseOrdem.css";
import "assets/css/loading.css";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import "assets/css/printModal.css";

// services
import { showMessage, showQuestion } from "../../../services/message.js";
import { api_GET, api_POST } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";
import { formateDate, formateDateandTimeComplete } from "../../../helpers/formats";

// views
import ModalPesquisa from "./ModalPesquisa.jsx";
import ModalAdicionarInconformidade from "../../shared/ModalAdicionarInconformidade.jsx";
import ModalDetalhesColetaItem from "../../shared/ModalDetalhesColetaItem.jsx";
import ModalDetalhesInconformidade from "../../shared/ModalDetalhesInconformidade.jsx";
import ModalHistoricoAvaliacao from "./ModalHistoricoAvaliacao.jsx";
import ModalAcoesColetor from "../../shared/ModalAcoesColetor.jsx";
import ModalAdicionarOcorrencia from "../../shared/ModalAdicionarOcorrencia.jsx";

//Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

export default function AnaliseOrdemColetaMap({ history }) {
    const classes = useStyles();

    const session = getSessionCookie();
    const location = useLocation();

    const { register, handleSubmit, errors } = useForm({ mode: "onBlur" });

    const [visibilidadeCamposOrdem, setVisibilidadeCamposOrdem] = useState(true);

    const [showLoading, setshowLoading] = useState(false);

    //State para manipular a visualização do veiculo
    const [visualizarRastreio, setVisualizarRastreio] = useState({ value: "Nenhum", label: "Nenhum" })
    const optionsVisualizarRastreio = [
        { value: "Nenhum", label: "Nenhum" },
        { value: "Celular", label: "Celular" },
        { value: "Integração GPS", label: "GPS" }
    ];

    const [permissoesEspeciais, setpermissoesEspeciais] = useState([]);
    const loadPermissoesEspeciais = () => {
        api_GET(`usuario/GetPermissoesEspeciais/${session.usuarioId}`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setpermissoesEspeciais(result.data);
            }
        });
    }

    const [showLista, setshowLista] = useState(false);
    const [ordemColeta, setOrdemColeta] = useState(null);
    const loadOrdemColeta = (ordemColetaId) => {
        setshowLoading(true);
        api_GET(`ordemcoleta/${ordemColetaId}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setOrdemColeta(result.data);
                if (result.data.ordemColetaPontoColeta != null && result.data.ordemColetaPontoColeta.length > 0)
                    setcenterMap([result.data.ordemColetaPontoColeta[0].pontoColeta.latitude, result.data.ordemColetaPontoColeta[0].pontoColeta.longitude])

            }
        });
    }
    useEffect(() => {
        handleExibicaoBotoes();
    }, [ordemColeta]);

    useEffect(() => {
        loadPermissoesEspeciais();
        let urls = history.location.search;
        let params = queryString.parse(urls);
        loadOrdemColeta(params.id);
    }, [location]);

    // Exibição dos botões de ação
    const [exibicaoBotaoContestar, setexibicaoBotaoContestar] = useState(false);
    const [exibicaoBotaoAprovar, setexibicaoBotaoAprovar] = useState(false);
    const [exibicaoBotaoReprovar, setexibicaoBotaoReprovar] = useState(false);
    const [exibicaoBotaoNaoAvaliar, setExibicaoBotaoNaoAvaliar] = useState();
    const handleExibicaoBotoes = () => {
        setexibicaoBotaoContestar(false);
        setexibicaoBotaoAprovar(false);
        setexibicaoBotaoReprovar(false);
        setExibicaoBotaoNaoAvaliar(false);

        if (ordemColeta != null
            && (ordemColeta.statusExecucaoOrdemColeta == "Finalizada" || ordemColeta.statusExecucaoOrdemColeta == "Não Executada")
            && (ordemColeta.statusAvaliacaoOrdemColeta == "Pendente" || ordemColeta.statusAvaliacaoOrdemColeta == "Justificada" || ordemColeta.statusAvaliacaoOrdemColeta == "Aprovação Automática"
                || ordemColeta.statusAvaliacaoOrdemColeta == "Aprovada" || ordemColeta.statusAvaliacaoOrdemColeta == "Reprovada")
            && (session.perfil == "Master" || permissoesEspeciais.filter(f => f.permissao == "contestar_os").length > 0))
            setexibicaoBotaoContestar(true);

        if (ordemColeta != null
            && (ordemColeta.statusExecucaoOrdemColeta == "Finalizada" || ordemColeta.statusExecucaoOrdemColeta == "Não Executada")
            && (ordemColeta.statusAvaliacaoOrdemColeta == "Pendente" || ordemColeta.statusAvaliacaoOrdemColeta == "Justificada" || ((session.perfil == "Gestor" || session.perfil == "Master" || session.perfil == "Encarregado de Monitoramento") && ordemColeta.statusAvaliacaoOrdemColeta != "Aprovada"))
            && (session.perfil == "Master" || permissoesEspeciais.filter(f => f.permissao == "aprovar_os").length > 0))
            setexibicaoBotaoAprovar(true);

        if (ordemColeta != null
            && (ordemColeta.statusExecucaoOrdemColeta == "Finalizada" || ordemColeta.statusExecucaoOrdemColeta == "Não Executada")
            && (ordemColeta.statusAvaliacaoOrdemColeta == "Pendente" || ordemColeta.statusAvaliacaoOrdemColeta == "Justificada" || ((session.perfil == "Gestor" || session.perfil == "Master"  || session.perfil == "Encarregado de Monitoramento") && ordemColeta.statusAvaliacaoOrdemColeta != "Reprovada"))
            && (session.perfil == "Master" || permissoesEspeciais.filter(f => f.permissao == "reprovar_os").length > 0))
            setexibicaoBotaoReprovar(true);

        if (ordemColeta != null
            && (ordemColeta.statusExecucaoOrdemColeta == "Finalizada" || ordemColeta.statusExecucaoOrdemColeta == "Não Executada")
            && (ordemColeta.statusAvaliacaoOrdemColeta == "Pendente" || ordemColeta.statusAvaliacaoOrdemColeta == "Justificada" || ((session.perfil == "Gestor" || session.perfil == "Master") && ordemColeta.statusAvaliacaoOrdemColeta != "Reprovada"))
            && (session.perfil == "Master" || permissoesEspeciais.filter(f => f.permissao == "reprovar_os").length > 0))
            setExibicaoBotaoNaoAvaliar(true);
    }

    // Detalhes Coleta
    const [viewColetas, setviewColetas] = useState(true);
    const [stateModalDetalhesColetaItem, setstateModalDetalhesColetaItem] = useState(false);
    const [itemModalDetalhesColetaItem, setItemModalDetalhesColetaItem] = useState(null);
    const openModalDetalhesColeta = (pontocoleta) => {
        setItemModalDetalhesColetaItem(pontocoleta);
        setstateModalDetalhesColetaItem(true);
    }

    const ReturnModalDetalhesColetaItem = () => {
        setstateModalDetalhesColetaItem(false);
    }

    // Ações Coletor
    const [viewAcoesColetor, setviewAcoesColetor] = useState(false);
    const [ordemColetaAcaoColetorId, setordemColetaAcaoColetorId] = useState(null);
    const openModalAcoesColetor = (acao) => {
        setordemColetaAcaoColetorId(acao != null ? acao.ordemColetaAcaoColetorId : null);
        setstateModalAcoesColetor(true);
    }

    //Ocorrencia
    const [viewOcorrencias, setViewOcorrencias] = useState(false);

    //Alertas
    const [viewalertas, setViewAlertas] = useState(false);


    // Inconformidades
    const [viewInconformidade, setviewInconformidade] = useState(false);
    const [stateModalDetalhesInconformidade, setstateModalDetalhesInconformidade] = useState(false);
    const [itemModalDetalhesInconformidade, setItemModalDetalhesInconformidade] = useState(null);
    const openModalDetalhesInconformidade = (inconformidade) => {
        setItemModalDetalhesInconformidade(inconformidade);
        setstateModalDetalhesInconformidade(true);
    }
    const ReturnModalDetalhesInconformidade = (inconformidade) => {
        if (inconformidade != null) {
            loadOrdemColeta(ordemColeta.ordemColetaId);
        }
        setstateModalDetalhesInconformidade(false);
    }

    // Add Inconformidade
    const [enableAddInconformidade, setenableAddInconformidade] = useState(false);
    const [itemModalAddInconformidade, setitemModalAddInconformidade] = useState(null)
    const [stateModalInconformidade, setstateModalInconformidade] = useState(false);
    const ReturnModalAdicionarInconformidade = (inconformidade) => {
        if (inconformidade != null) {
            let updateOrdem = ordemColeta;
            if (updateOrdem.ordemColetaInconformidade == null)
                updateOrdem.ordemColetaInconformidade = [];

            updateOrdem.ordemColetaInconformidade.push(inconformidade);
            setOrdemColeta(updateOrdem);
        }
        setstateModalInconformidade(false);
    }
    const AddInconformidade = () => {
        showMessage("Aviso", "Clique no mapa, no local da inconformidade!", 'info', function () { setenableAddInconformidade(true) });
    }

    // Add Ocorrência
    const [enableAddOcorrencia, setenableAddOcorrencia] = useState(false);
    const [itemModalAddOcorrencia, setitemModalAddOcorrencia] = useState(null)
    const [stateModalOcorrencia, setstateModalOcorrencia] = useState(false);
    const ReturnModalAdicionarOcorrencia = (ocorrencia) => {
        if (ocorrencia != null) {
            let updateOrdem = ordemColeta;
            if (updateOrdem.ordemColetaAcaoColetor == null)
                updateOrdem.ordemColetaAcaoColetor = [];

            updateOrdem.ordemColetaAcaoColetor.push(ocorrencia);
            setOrdemColeta(updateOrdem);
        }
        setstateModalOcorrencia(false);
    }

    const AddOcorrencia = () => {
        showMessage("Aviso", "Clique no mapa, no local da ocorrência!", 'info', function () { setenableAddOcorrencia(true) });
    }

    // Percurso Percorrido
    const [lineRastreio, setLineRastreio] = useState([]);
    const [dadosRastreamento, setDadosRastreamento] = useState([]);
    const [viewRota, setviewRota] = useState(false);
    useEffect(() => {
        if (viewRota && visualizarRastreio.value != "Nunhum") {
            handleDadosRastreamento();
        }
    }, [viewRota, visualizarRastreio]);
    const handleDadosRastreamento = () => {
        setshowLoading(true);
        api_GET(`ordemColeta/GetRastreamentoVeiculo/${ordemColeta.ordemColetaId}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                const data = result.data?.filter(x => x.origemRastreio == visualizarRastreio.value)
                const polyline = createPolyline(data);
                loadOrdemColeta(ordemColeta.ordemColetaId);
                setLineRastreio(polyline);
                setDadosRastreamento(data);
            }
        });
    }

    const createPolyline = (data) => {
        const polyline = [];
        for (let i = 1; i < data.length; i++) {
            polyline.push({
                from_lat: data[i - 1].latitude,
                from_long: data[i - 1].longitude,
                id: i - 1,
                to_lat: data[i].latitude,
                to_long: data[i].longitude,
                origemRastreio: data[i].origemRastreio
            });
        }
        return polyline;
    };

    // Mapa
    const [centerMap, setcenterMap] = useState([-3.7281458, -38.5762694]);
    const [showLegendas, setShowLegendas] = useState(false);
    const handleClickMap = (e) => {
        if (enableAddInconformidade) {
            setenableAddInconformidade(false);
            setitemModalAddInconformidade({ lat: e.latlng.lat, lng: e.latlng.lng })
            setstateModalInconformidade(true);
        }

        if (enableAddOcorrencia) {
            setenableAddOcorrencia(false);
            setitemModalAddOcorrencia({ lat: e.latlng.lat, lng: e.latlng.lng });
            setstateModalOcorrencia(true);
        }
    }

    const handleVisualizarRastreio = (visualizar) => {
        if (visualizar.value != "Nenhum") {
            setVisualizarRastreio(visualizar)
            setviewRota(true)
        } else {
            setVisualizarRastreio(visualizar)
            setviewRota(false)
        }
    }

    const [mapaSatelite, setmapaSatelite] = useState(false);

    // Ações de Avaliação da Ordem
    const ConfirmarContestacao = () => {
        if (ordemColeta.ordemColetaInconformidade.filter(f => f.situacao == "Aguardando Justificativa").length == 0) {
            showMessage("Aviso", "Antes de confirmar a contestação, é necessário marcar quais inconformidades serão contestadas!", 'warning', null);
            return;
        }

        showQuestion("Aviso", "Tem certeza que deseja Contestar a Ordem de Serviço?", 'question', function (result) {
            if (result) {
                setshowLoading(true);
                let json_post = {
                    ordemColetaId: ordemColeta.ordemColetaId,
                    usuarioId: session.usuarioId,
                    situacao: 'Contestada',
                    tipoAvaliacao: ordemColeta.statusAvaliacaoOrdemColeta == "Pendente" ? "Inconformidade" : "Justificativa"
                }

                api_POST('AvaliacaoColeta/ConfirmarContestacao', json_post).then(result => {
                    if (result.status !== 200) {
                        setshowLoading(false);
                        showMessage("Aviso", result.message, 'error', null);
                    }
                    else {
                        showMessage("Atenção", "Contestação confirmada com sucesso!", 'success', function () { });
                        loadOrdemColeta(ordemColeta.ordemColetaId);
                    }
                });
            }
        });
    }

    const ConfirmarReprovacao = () => {
        if (ordemColeta.ordemColetaInconformidade.filter(f => f.situacao == "Aguardando Justificativa" || f.situacao == "Aguardando Avaliação de Justificativa").length > 0) {
            showMessage("Aviso", "Para confirmar a reprovação da ordem, é necessário que todas as contestações tenham sido justificadas e avaliadas!", 'warning', null);
            return;
        }

        if (ordemColeta.ordemColetaInconformidade.filter(f => f.situacao == "Justificativa Reprovada").length == 0) {
            showMessage("Aviso", "Para confirmar a reprovação da ordem, é necessário que exista ao menos uma contestação com justificativa reprovada!", 'warning', null);
            return;
        }

        showQuestion("Aviso", "Tem certeza que deseja Reprovar a Ordem de Serviço?", 'question', function (result) {
            if (result) {
                setshowLoading(true);
                let json_post = {
                    ordemColetaId: ordemColeta.ordemColetaId,
                    usuarioId: session.usuarioId,
                    situacao: 'Reprovada',
                    tipoAvaliacao: ordemColeta.statusAvaliacaoOrdemColeta == "Pendente" ? "Inconformidade" : "Justificativa"
                }

                api_POST('AvaliacaoColeta/ConfirmarReprovacao', json_post).then(result => {
                    if (result.status !== 200) {
                        setshowLoading(false);
                        showMessage("Aviso", result.message, 'error', null);
                    }
                    else {
                        showMessage("Atenção", "Reprovação confirmada com sucesso!", 'success', function () { });
                        loadOrdemColeta(ordemColeta.ordemColetaId);
                    }
                });
            }
        });
    }

    const ConfirmarAprovacao = () => {
        if (ordemColeta.ordemColetaInconformidade.filter(f => f.situacao == "Aguardando Justificativa" || f.situacao == "Aguardando Avaliação de Justificativa" || f.situacao == "Justificativa Reprovada").length > 0) {
            showMessage("Aviso", "Para confirmar a aprovação da ordem, todas as contestações devem ter sido aprovadas!", 'warning', null);
            return;
        }
        showQuestion("Aviso", "Tem certeza que deseja Aprovar a Ordem de Serviço?", 'question', function (result) {
            if (result) {
                setshowLoading(true);
                let json_post = {
                    ordemColetaId: ordemColeta.ordemColetaId,
                    usuarioId: session.usuarioId,
                    situacao: 'Aprovada',
                    tipoAvaliacao: ordemColeta.statusAvaliacaoOrdemColeta == "Pendente" ? "Inconformidade" : "Justificativa"
                }

                api_POST('AvaliacaoColeta/ConfirmarAprovacao', json_post).then(result => {
                    if (result.status !== 200) {
                        setshowLoading(false);
                        showMessage("Aviso", result.message, 'error', null);
                    }
                    else {
                        showMessage("Atenção", "Aprovação confirmada com sucesso!", 'success', function () { });
                        loadOrdemColeta(ordemColeta.ordemColetaId);
                    }
                });
            }
        });
    }

    const ConfirmarNaoAvaliar = () => {
        showQuestion("Aviso", "Tem certeza que deseja Não Avaliar essa Ordem de Serviço?", 'question', function (result) {
            if (result) {
                setshowLoading(true);
                let json_post = {
                    ordemColetaId: ordemColeta.ordemColetaId,
                    usuarioId: session.usuarioId,
                    situacao: 'Não Avaliada',
                    tipoAvaliacao: ordemColeta.statusAvaliacaoOrdemColeta == "Pendente" ? "Inconformidade" : "Justificativa"
                }

                api_POST('AvaliacaoColeta/ConfirmarNaoAvaliar', json_post).then(result => {
                    if (result.status !== 200) {
                        setshowLoading(false);
                        showMessage("Aviso", result.message, 'error', null);
                    }
                    else {
                        showMessage("Atenção", "Aprovação confirmada com sucesso!", 'success', function () { });
                        loadOrdemColeta(ordemColeta.ordemColetaId);
                    }
                });
            }
        });
    }

    // Icones    
    const handleIconColeta = (item) => {
        let icon = "";
        if (item.statusColeta == "Programada")
            icon = "avulso-azul"
        else if (item.statusColeta == "Execução Iniciada")
            icon = "avulso-roxo"
        else if (item.statusColeta == "Execução Parcial")
            icon = "avulso-amarelo"
        else if (item.statusColeta == "Execução Total")
            icon = "avulso-verde"
        else if (item.statusColeta == "Não Execução")
            icon = "avulso-vermelho"
        return new L.Icon({
            iconUrl: require('assets/img/icons/' + icon + '.png'),
            iconRetinaUrl: require('assets/img/icons/' + icon + '.png'),
        });
    }

    const handleIconInconformidade = (item) => {
        let icon = "";
        if (item.situacao == "Aguardando Contestação")
            icon = "inconformidade-azul"
        else if (item.situacao == "Aguardando Justificativa")
            icon = "inconformidade-amarelo"
        else if (item.situacao == "Aguardando Avaliação de Justificativa")
            icon = "inconformidade-roxo"
        else if (item.situacao == "Justificativa Aprovada")
            icon = "inconformidade-verde"
        else if (item.situacao == "Justificativa Reprovada")
            icon = "inconformidade-vermelho"

        return new L.Icon({
            iconUrl: require('assets/img/icons/' + icon + '.png'),
            iconSize: [28, 33],
            iconRetinaUrl: require('assets/img/icons/' + icon + '.png')
        });
    }

    const handleIconAlertas = (item) => {
        let icon = "";
        if (item.situacao == "Aguardando Contestação")
            icon = "alerta-azul"
        else if (item.situacao == "Aguardando Justificativa")
            icon = "alerta-amarelo"
        else if (item.situacao == "Aguardando Avaliação de Justificativa")
            icon = "alerta-roxo"
        else if (item.situacao == "Justificativa Aprovada")
            icon = "alerta-verde"
        else if (item.situacao == "Justificativa Reprovada")
            icon = "alerta-vermelho"
        return new L.Icon({
            iconUrl: require('assets/img/icons/' + icon + '.png'),
            iconSize: [28, 33],
            iconRetinaUrl: require('assets/img/icons/' + icon + '.png')
        });
    }


    const handleIconPoint = () => {
        return new L.Icon({
            iconUrl: require('assets/img/icons/point.png'),
            iconRetinaUrl: require('assets/img/icons/point.png'),
            iconSize: [22, 27],
        });
    }

    const handleIconAcoesColetor = (item) => {
        let icon = "";
        if (item.tipoAcao == "Início da Execução" || item.tipoAcao == "Reinício da Execução")
            icon = "marker-start";
        else if (item.tipoAcao == "Pausa da Execução")
            icon = "marker-pause";
        else if (item.tipoAcao == "Suspensão da Execução" || item.tipoAcao == "Finalização Manual" || item.tipoAcao == "Finalização Automática")
            icon = "marker-close";
        else if (item.tipoAcao == "Ocorrência")
            icon = "marker-ocurrency";
        else if (item.tipoAcao == "Destinação")
            icon = "marker-destination";
        else if (item.tipoAcao == "Descarregar" || item.tipoAcao == "Descarregar Sem Comprovante")
            icon = "marker-unload";

        return new L.Icon({
            iconUrl: require('assets/img/icons/' + icon + '.png'),
            iconSize: [32, 40],
            iconRetinaUrl: require('assets/img/icons/' + icon + '.png'),
        });
    }

    const handleIconPesquisa = (item) => {
        if (item.categoria == "Ecoponto")
            return new L.Icon({
                iconUrl: require('assets/img/icons/ecoponto-cinza.png'),
                iconRetinaUrl: require('assets/img/icons/ecoponto-cinza.png'),
            });
        else if (item.categoria == "Plano de Trabalho")
            return new L.Icon({
                iconUrl: require('assets/img/icons/planotrabalho-cinza.png'),
                iconRetinaUrl: require('assets/img/icons/planotrabalho-cinza.png'),
            });
        else if (item.categoria == "Avulso")
            return new L.Icon({
                iconUrl: require('assets/img/icons/avulso-cinza.png'),
                iconRetinaUrl: require('assets/img/icons/avulso-cinza.png'),
            });
    }

    // Pesquisa
    const [listaPesquisa, setListaPesquisa] = useState([]);
    const [stateModalPesquisa, setstateModalPesquisa] = useState(false);
    const ReturnModalPesquisa = (listaPesquisa) => {
        setListaPesquisa(listaPesquisa);
        setstateModalPesquisa(false);
    }

    // Tabela
    const columnsProp = [
        { title: 'Sequencia', field: "sequencia" },
        { title: 'Status', field: "statusColeta" },
        { title: 'Endereço', field: "pontoColeta", render: (rowData) => rowData && (rowData.pontoColeta.logradouro + ", " + rowData.pontoColeta.numeroLogradouro + ", " + rowData.pontoColeta.bairro) },
        { title: 'Execução Avulsa', field: "coletaAvulsa", render: (rowData) => rowData && (rowData.coletaAvulsa ? "Sim" : "Não") }
    ]

    // Histórico de avaliação da ordem
    const [stateModalHistoricoAvaliacao, setstateModalHistoricoAvaliacao] = useState(false);
    const ReturnModalHistoricoAvaliacao = () => {
        setstateModalHistoricoAvaliacao(false);
    }

    // Ações do Coletor
    const [stateModalAcoesColetor, setstateModalAcoesColetor] = useState(false);
    const ReturnModalAcoesColetor = () => {
        setstateModalAcoesColetor(false);
        // para recarrega as ações na ordem
        loadOrdemColeta(ordemColeta.ordemColetaId)
    }

    // Atualizar Rastreamento
    const AtualizaRastreamentoVeiculo = () => {
        setshowLoading(true);
        api_GET(`ordemColeta/AtualizaRastreamentoVeiculos/${ordemColeta.ordemColetaId}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Atualização concluída!", 'success', () => { window.location.reload() });
            }
        });
    }

    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => setTooltipOpen(!tooltipOpen);

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label style={{ marginRight: "20px" }}>Carregando...</label>
                        <Spinner size="sm" color="info" />
                    </div>
                </div>
            }
            <div className="">
                <Container className="mt-2" fluid>
                    <Card className="shadow">
                        <CardBody>
                            <Row className="d-flex justify-content-end items-align-center mb-0" >
                                <span>
                                    <Button onClick={() => setVisibilidadeCamposOrdem(!visibilidadeCamposOrdem)} id={'Tooltip-aviso'}>
                                        {visibilidadeCamposOrdem ? <FontAwesomeIcon icon={faAngleDown} /> : <FontAwesomeIcon icon={faAngleUp} />}
                                    </Button>
                                    <TooltipAviso
                                        placement={"bottom"}
                                        isOpen={tooltipOpen}
                                        target={"Tooltip-aviso"}
                                        toggle={toggle}
                                    >
                                        Visualização do Cabeçalho
                                    </TooltipAviso>
                                </span>
                            </Row>
                            <Row style={{ maxHeight: visibilidadeCamposOrdem ? "600px" : "0px", transition: "all .5s", overflow: "hidden" }} className="mb-0">
                                <Col md="6" lg="2">
                                    <label className="form-control-label" htmlFor="input-address" >
                                        Plano de Trabalho: <p>{(ordemColeta != null && ordemColeta.setorColeta != null) ? ordemColeta.setorColeta.descricao : "Ordem Avulsa"}</p>
                                    </label>
                                </Col>
                                <Col md="6" lg="1">
                                    <label className="form-control-label" htmlFor="input-address" >
                                        Data: <p>{ordemColeta != null && formateDate(ordemColeta.dataProgramacao)}</p>
                                    </label>
                                </Col>
                                <Col md="6" lg="1">
                                    <label className="form-control-label" htmlFor="input-address" >
                                        Recurso: <p>{ordemColeta != null && ordemColeta.veiculo.placa}</p>
                                    </label>
                                </Col>
                                <Col md="6" lg="2">
                                    <label className="form-control-label" htmlFor="input-address" >
                                        Status Avaliação <p>{ordemColeta != null && ordemColeta.statusAvaliacaoOrdemColeta}</p>
                                    </label>
                                </Col>
                                <Col md="6" lg="3">
                                    <label className="form-control-label" htmlFor="input-address" >
                                        Operador: <p>{ordemColeta != null && ordemColeta.usuarioOperadorColeta.nome}</p>
                                    </label>
                                </Col>
                                <Col md="6" lg="3">
                                    <label className="form-control-label" htmlFor="input-address" >
                                        Modalidade: <p>{ordemColeta != null && ordemColeta.modalidadeColeta.descricao}</p>
                                    </label>
                                </Col>
                                {ordemColeta != null && ordemColeta.veiculo.categoria === "Veículo" &&
                                    <>
                                        <Col md="6" lg="2">
                                            <label className="form-control-label " htmlFor="input-address" >
                                                Origem Rastreio: <p className="mb-0">{ordemColeta.origemRastreio === null ? "Celular" : ordemColeta.origemRastreio}</p>
                                            </label>
                                        </Col>
                                        <Col md="6" lg="2">
                                            <label className="form-control-label " htmlFor="input-address" >
                                                Status Integração Rastreio: <p className="mb-0">{ordemColeta !== null && ordemColeta.statusRastreamento}</p>
                                            </label>
                                        </Col>
                                        <Col md="6" lg="4" className="mb-0">
                                            <Button color="info" className="btn-sm" type="button" onClick={() => AtualizaRastreamentoVeiculo()}>Atualizar Rastreamento</Button>
                                        </Col>
                                    </>
                                }
                            </Row>
                            <div className="d-flex justify-content-between flex-wrap align-items-center mb-1">
                                <div style={{ zIndex: 9999 }}>
                                    <div className="pl-0 custom-control custom-checkbox" >
                                        <label className="form-control-label" htmlFor="input-address" >
                                            Visualização de Rastreamento
                                        </label>
                                        <Select
                                            name="visualizarRastreio"
                                            options={optionsVisualizarRastreio}
                                            onChange={(value) => handleVisualizarRastreio(value)}
                                            value={optionsVisualizarRastreio != null && optionsVisualizarRastreio.find(obj => obj.value == visualizarRastreio.value)}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            className="custom-control-input"
                                            id="customCheck1"
                                            type="checkbox"
                                            defaultChecked
                                            onClick={(e) => setviewColetas(e.target.checked)}
                                            value={viewColetas}
                                        />
                                        <label className="custom-control-label" htmlFor="customCheck1">
                                            Locais de Execução
                                        </label>
                                    </div>
                                </div>
                                <div>
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            className="custom-control-input"
                                            id="customCheck2"
                                            type="checkbox"
                                            onClick={(e) => setviewAcoesColetor(e.target.checked)}
                                        />
                                        <label className="custom-control-label" htmlFor="customCheck2">
                                            Ações Coletor
                                        </label>
                                    </div>
                                </div>
                                <div>
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            className="custom-control-input"
                                            id="customCheck3"
                                            type="checkbox"
                                            onClick={(e) => setViewOcorrencias(e.target.checked)}
                                        />
                                        <label className="custom-control-label" htmlFor="customCheck3">
                                            Ocorrências
                                        </label>
                                    </div>
                                </div>
                                <div >
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            className="custom-control-input"
                                            id="customCheck4"
                                            type="checkbox"
                                            onClick={(e) => setViewAlertas(e.target.checked)}
                                        />
                                        <label className="custom-control-label" htmlFor="customCheck4">
                                            Alertas
                                        </label>
                                    </div>
                                </div>
                                <div>
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            className="custom-control-input"
                                            id="customCheck5"
                                            type="checkbox"
                                            onClick={(e) => setviewInconformidade(e.target.checked)}
                                        />
                                        <label className="custom-control-label" htmlFor="customCheck5">
                                            Inconformidades
                                        </label>
                                    </div>
                                </div>

                                <div className="text-right">
                                    {visibilidadeCamposOrdem &&
                                        <Navbar className="pt-0 pb-0">
                                            <span class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block">
                                                <FontAwesomeIcon icon={faBars} />
                                            </span>
                                            <div class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
                                            </div>
                                            <Nav className="align-items-center d-none d-md-flex" navbar>
                                                <UncontrolledDropdown nav>
                                                    <DropdownToggle className="mr-0" nav>
                                                        <Media>
                                                            <Media>
                                                                <FontAwesomeIcon icon={faGears} />
                                                            </Media>
                                                        </Media>
                                                    </DropdownToggle>
                                                    <DropdownMenu className="dropdown-menu-arrow" right>
                                                        <DropdownItem onClick={() => setstateModalPesquisa(true)} style={{ cursor: "pointer" }}>
                                                            <FontAwesomeIcon icon={faMagnifyingGlassLocation} />
                                                            <span>Pesquisa</span>
                                                        </DropdownItem>
                                                        {ordemColeta != null && (session.perfil == "Master" || permissoesEspeciais.filter(f => f.permissao == "add_inconformidades_os").length > 0) &&
                                                            <div><DropdownItem divider />
                                                                <DropdownItem onClick={() => AddInconformidade()} style={{ cursor: "pointer" }}>
                                                                    <FontAwesomeIcon icon={faSquarePlus} />
                                                                    <span>Adicionar Inconformidade</span>
                                                                </DropdownItem>
                                                            </div>
                                                        }
                                                        {ordemColeta != null && (session.perfil == "Master" || permissoesEspeciais.filter(f => f.permissao == "add_ocorrencias_os").length > 0)
                                                            && (ordemColeta.statusExecucaoOrdemColeta != "Programada") &&
                                                            <div><DropdownItem divider />
                                                                <DropdownItem onClick={() => AddOcorrencia()} style={{ cursor: "pointer" }}>
                                                                    <FontAwesomeIcon icon={faSquarePlus} />
                                                                    <span>Adicionar Ocorrência</span>
                                                                </DropdownItem>
                                                            </div>
                                                        }
                                                        <DropdownItem divider />
                                                        <DropdownItem onClick={() => setstateModalHistoricoAvaliacao(true)} style={{ cursor: "pointer" }}>
                                                            <FontAwesomeIcon icon={faClipboardList} />
                                                            <span>Histórico de Avaliação</span>
                                                        </DropdownItem>
                                                        <DropdownItem divider />
                                                        <DropdownItem onClick={() => openModalAcoesColetor(null)} style={{ cursor: "pointer" }}>
                                                            <FontAwesomeIcon icon={faList} />
                                                            <span>Ações do Coletor</span>
                                                        </DropdownItem>
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </Nav>
                                        </Navbar>
                                    }
                                </div>
                            </div>
                            {visibilidadeCamposOrdem &&
                                <Row className="mb-2">
                                    <Col md="2" lg="2">
                                        <Button color="info" className="btn-sm" type="button" onClick={() => setshowLista(!showLista)}>{showLista ? "Ver Mapa" : "Ver Lista"}</Button>
                                    </Col>
                                </Row>
                            }
                            <Row className={showLista && classes.rowInvisible}>
                                <Col md="12" className={"no-print"}>
                                    <div id="map" >
                                        <Map center={centerMap} zoom={15} onClick={handleClickMap} className={!visibilidadeCamposOrdem ? "leaflet-container-full" : ""}>
                                            {mapaSatelite &&
                                                <ReactLeafletGoogleLayer googleMapsLoaderConf={{ KEY: 'AIzaSyCA4LC5FmVmZ84YbtuQT87xlLpYKcseJms' }} type={'satellite'} />
                                            }
                                            {!mapaSatelite &&
                                                <ReactLeafletGoogleLayer googleMapsLoaderConf={{ KEY: 'AIzaSyCA4LC5FmVmZ84YbtuQT87xlLpYKcseJms' }} type={'roadmap'} />
                                            }

                                            {(ordemColeta != null && ordemColeta.setorColeta != null && ordemColeta.setorColeta.delimitacaoGeograficaSetor != null) &&
                                                <GeoJSON data={JSON.parse(ordemColeta.setorColeta.delimitacaoGeograficaSetor.geoJson)}></GeoJSON>
                                            }

                                            <MarkerClusterGroup>

                                                {(viewColetas && ordemColeta != null && ordemColeta.ordemColetaPontoColeta != null) &&
                                                    ordemColeta.ordemColetaPontoColeta.map((m) => {
                                                        return <Marker key={m.ordemColetaPontoColetaId} position={[m.pontoColeta.latitude, m.pontoColeta.longitude]} icon={handleIconColeta(m)}
                                                            onClick={() => openModalDetalhesColeta(m)}>
                                                            <Tooltip direction='center' offset={[0, 0]} opacity={1} permanent>
                                                                <span>{m.sequencia}</span>
                                                            </Tooltip>
                                                        </Marker>
                                                    })
                                                }

                                                {(viewInconformidade && ordemColeta != null && ordemColeta.ordemColetaInconformidade != null) &&
                                                    ordemColeta.ordemColetaInconformidade.filter(x => x.categoria == "Inconformidade").map((m) => {
                                                        return <Marker key={m.ordemColetaInconformidadeId} position={[m.latitude, m.longitude]} icon={handleIconInconformidade(m)}
                                                            onClick={() => openModalDetalhesInconformidade(m)}>
                                                        </Marker>
                                                    })
                                                }

                                                {(viewalertas && ordemColeta != null && ordemColeta.ordemColetaInconformidade != null) &&
                                                    ordemColeta.ordemColetaInconformidade.filter(x => x.categoria == "Alerta").map((m) => {

                                                        return <Marker key={m.ordemColetaInconformidadeId} position={[m.latitude, m.longitude]} icon={handleIconAlertas(m)}
                                                            onClick={() => openModalDetalhesInconformidade(m)}>
                                                        </Marker>
                                                    })
                                                }

                                                {(viewAcoesColetor && ordemColeta != null && ordemColeta.ordemColetaAcaoColetor != null) &&
                                                    ordemColeta.ordemColetaAcaoColetor.filter(x => x.tipoAcao != "Ocorrência").map((m) => {
                                                        return <Marker key={m.ordemColetaAcaoColetorId} position={[m.latitude, m.longitude]} icon={handleIconAcoesColetor(m)}
                                                            onClick={() => openModalAcoesColetor(m)}>
                                                        </Marker>
                                                    })
                                                }

                                                {(viewOcorrencias && ordemColeta != null && ordemColeta.ordemColetaAcaoColetor != null) &&
                                                    ordemColeta.ordemColetaAcaoColetor.filter(x => x.tipoAcao == "Ocorrência").map((m) => {
                                                        return <Marker key={m.ordemColetaAcaoColetorId} position={[m.latitude, m.longitude]} icon={handleIconAcoesColetor(m)}
                                                            onClick={() => openModalAcoesColetor(m)}>
                                                        </Marker>
                                                    })
                                                }

                                                {listaPesquisa != null && listaPesquisa.map((m) => (
                                                    <Marker key={m.ordemColetaRastreamentoVeiculoId} position={[m.latitude, m.longitude]} icon={handleIconPesquisa(m)}></Marker>
                                                ))}


                                                {viewRota && lineRastreio.length > 0 && visualizarRastreio?.value != "Nenhum" &&
                                                    lineRastreio.filter(x => x.origemRastreio == visualizarRastreio.value).map(m => {
                                                        return <Polyline
                                                            key={m.id}
                                                            positions={[[m.from_lat, m.from_long], [m.to_lat, m.to_long]]} color={'red'} />
                                                    })
                                                }
                                            </MarkerClusterGroup>

                                            {viewRota && dadosRastreamento.length > 0 && visualizarRastreio?.value != "Nenhum" &&
                                                dadosRastreamento.filter(x => x.origemRastreio == visualizarRastreio.value).map((m, index) => {
                                                    return <Marker key={index} position={[m.latitude, m.longitude]} icon={handleIconPoint()}>
                                                        <Tooltip direction='center' className={"leaflet-tooltip-red"} offset={[0, 0]} opacity={1} permanent>
                                                            <span>{m.sequencia}</span>
                                                        </Tooltip>
                                                        <Popup>
                                                            {formateDateandTimeComplete(m.dataHoraGPS)}
                                                        </Popup>
                                                    </Marker>
                                                })
                                            }

                                        </Map>
                                    </div>
                                </Col>
                            </Row>
                            {showLista &&
                                <Row className={!showLista && classes.rowInvisible}>
                                    <Col md="12">
                                        <MaterialTable
                                            title="Itens da Ordem de Serviço"
                                            columns={columnsProp}
                                            data={ordemColeta.ordemColetaPontoColeta}
                                            options={table_style}
                                            actions={[
                                                {
                                                    icon: 'search',
                                                    tooltip: 'Detalhes da Coleta',
                                                    onClick: (event, rowData) => openModalDetalhesColeta(rowData)
                                                }
                                            ]}
                                            localization={table_translate}
                                        />
                                    </Col>
                                </Row>
                            }
                            <Row className="mt-2">
                                <Col md="6">
                                    <Button color="info" outline className="btn-sm" type="button" onClick={() => setShowLegendas(!showLegendas)}>Legendas</Button>
                                </Col>
                                <Col md="6 text-right">
                                    <Button color="info" outline className="btn-sm" type="button" onClick={() => setmapaSatelite(!mapaSatelite)}>{mapaSatelite ? "Mapa" : "Satélite"}</Button>
                                </Col>
                            </Row>
                            {visibilidadeCamposOrdem &&
                                <Row>
                                    <Col md="12" className="text-center">
                                        {exibicaoBotaoContestar &&
                                            <Button color="warning" type="button" onClick={() => ConfirmarContestacao()}>
                                                Contestar Ordem
                                            </Button>
                                        }
                                        {exibicaoBotaoAprovar &&
                                            <Button color="success" type="button" onClick={() => ConfirmarAprovacao()}>
                                                Aprovar Ordem
                                            </Button>
                                        }
                                        {exibicaoBotaoReprovar &&
                                            <Button color="danger" type="button" onClick={() => ConfirmarReprovacao()}>
                                                Reprovar Ordem
                                            </Button>
                                        }
                                        {exibicaoBotaoNaoAvaliar &&
                                            <Button color="secondary" class="btn btn-outline-secondary" type="button" onClick={() => ConfirmarNaoAvaliar()}>
                                                Não Avaliar
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                            }
                            {showLegendas &&
                                <div>
                                    <Row className="mt-2">
                                        <Col md="12" className="mb-2">
                                            <strong>
                                                Legendas Coleta
                                            </strong>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/avulso-azul.png')}
                                            />
                                            <br />
                                            <label>Coleta Programada</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/avulso-roxo.png')}
                                            />
                                            <br />
                                            <label>Execução Iniciada</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/avulso-amarelo.png')}
                                            />
                                            <br />
                                            <label>Execução Parcial</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/avulso-verde.png')}
                                            />
                                            <br />
                                            <label>Execução Total</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/avulso-vermelho.png')}
                                            />
                                            <br />
                                            <label>Não Execução</label>
                                        </Col>
                                    </Row>
                                    <Row className="mt-4">
                                        <Col md="12" className="mb-2">
                                            <strong>
                                                Legendas Alertas
                                            </strong>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/alerta-azul.png')}
                                            />
                                            <br />
                                            <label>Aguardando Contestação</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/alerta-amarelo.png')}
                                            />
                                            <br />
                                            <label>Contestado</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/alerta-roxo.png')}
                                            />
                                            <br />
                                            <label>Justificado</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/alerta-verde.png')}
                                            />
                                            <br />
                                            <label>Aprovado</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/alerta-vermelho.png')}
                                            />
                                            <br />
                                            <label>Reprovado</label>
                                        </Col>
                                    </Row>
                                    <Row className="mt-4">
                                        <Col md="12" className="mb-2">
                                            <strong>
                                                Legendas Inconformidade
                                            </strong>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/inconformidade-azul.png')}
                                            />
                                            <br />
                                            <label>Aguardando Contestação</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/inconformidade-amarelo.png')}
                                            />
                                            <br />
                                            <label>Contestado</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/inconformidade-roxo.png')}
                                            />
                                            <br />
                                            <label>Justificado</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/inconformidade-verde.png')}
                                            />
                                            <br />
                                            <label>Aprovado</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/inconformidade-vermelho.png')}
                                            />
                                            <br />
                                            <label>Reprovado</label>
                                        </Col>
                                    </Row>
                                    <Row className="mt-4">
                                        <Col md="12" className="mb-2">
                                            <strong>
                                                Legendas Ações Coletor
                                            </strong>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/marker-start.png')}
                                            />
                                            <br />
                                            <label>Início da Execução</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/marker-pause.png')}
                                            />
                                            <br />
                                            <label>Pausa na Execução</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/marker-close.png')}
                                            />
                                            <br />
                                            <label>Suspensão/Finalização</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/marker-destination.png')}
                                            />
                                            <br />
                                            <label>Destinação</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/marker-unload.png')}
                                            />
                                            <br />
                                            <label>Descarregar</label>
                                        </Col>
                                        <Col md="2">
                                            <img
                                                alt={"..."}
                                                height="40"
                                                src={require('assets/img/icons/marker-ocurrency.png')}
                                            />
                                            <br />
                                            <label>Ocorrência</label>
                                        </Col>
                                    </Row>
                                </div>
                            }
                        </CardBody>
                    </Card>
                </Container>
            </div>

            {stateModalDetalhesColetaItem &&
                <ModalDetalhesColetaItem
                    stateModalDetalhesColetaItem={stateModalDetalhesColetaItem}
                    item={itemModalDetalhesColetaItem}
                    handleReturn={ReturnModalDetalhesColetaItem}
                />
            }
            {stateModalDetalhesInconformidade &&
                <ModalDetalhesInconformidade
                    stateModalDetalhesInconformidade={stateModalDetalhesInconformidade}
                    ordemColeta={ordemColeta}
                    item={itemModalDetalhesInconformidade}
                    handleReturn={ReturnModalDetalhesInconformidade}
                    showLoading={setshowLoading}
                    permissoesEspeciais={permissoesEspeciais}
                />
            }
            {stateModalInconformidade &&
                <ModalAdicionarInconformidade
                    stateModalInconformidade={stateModalInconformidade}
                    item={itemModalAddInconformidade}
                    ordemColeta={ordemColeta}
                    handleReturn={ReturnModalAdicionarInconformidade}
                    showLoading={setshowLoading}
                />
            }
            {stateModalOcorrencia &&
                <ModalAdicionarOcorrencia
                    stateModalOcorrencia={stateModalOcorrencia}
                    item={itemModalAddOcorrencia}
                    ordemColeta={ordemColeta}
                    handleReturn={ReturnModalAdicionarOcorrencia}
                    showLoading={setshowLoading}
                />
            }
            {stateModalPesquisa &&
                <ModalPesquisa
                    stateModalPesquisa={stateModalPesquisa}
                    ordemColeta={ordemColeta}
                    handleReturn={ReturnModalPesquisa}
                    showLoading={setshowLoading}
                />
            }
            {stateModalHistoricoAvaliacao &&
                <ModalHistoricoAvaliacao
                    stateModalHistoricoAvaliacao={stateModalHistoricoAvaliacao}
                    ordemColeta={ordemColeta}
                    handleReturn={ReturnModalHistoricoAvaliacao}
                />
            }
            {stateModalAcoesColetor &&
                <ModalAcoesColetor
                    stateModalAcoesColetor={stateModalAcoesColetor}
                    ordemColeta={ordemColeta}
                    handleReturn={ReturnModalAcoesColetor}
                    ordemColetaAcaoColetorId={ordemColetaAcaoColetorId}
                />
            }
        </>
    );
}

const useStyles = makeStyles((theme) => ({
    rowInvisible: {
        display: 'none'
    }
}));
